import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, IconButton, Button, Box, Menu, MenuItem, Avatar } from '@mui/material';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/logoVerde.svg';
import config from '../config';
import { useLocation } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const Header = ({ user, setUser }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null); // Estado para el menu del usuario
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const handleUserMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePerfil = () => {
    handleUserMenuClose();
    navigate('/profile'); 
  };

  const handleLogout = () => {
    handleUserMenuClose();
    localStorage.removeItem('user'); 
    localStorage.removeItem('token');
    setUser(null); 
    navigate('/login');
  };

  return (
    <>
      <AppBar position="sticky" sx={{ backgroundColor: '#173031', color:'white' }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {user && (
            <IconButton edge="start" color="inherit" onClick={toggleSidebar}>
              <Logo style={{ height: 40, marginRight: 2 }} />
              <Typography
                variant="h6"
                sx={{ fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', color:'#64AE37'}}
                onClick={() => navigate(user ? '/dashboard' : '/login')}
              >
                {config.appName}
              </Typography>
            </IconButton>
          )}

          {user && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton onClick={handleUserMenuOpen} sx={{ p: 0 }}>
                <AccountCircleIcon sx={{ fontSize: 40, color: 'white' }} />
              </IconButton>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 'bold', cursor: 'pointer', color: 'white' }}
                onClick={handleUserMenuOpen}
              >
                {user.nombre}
              </Typography>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleUserMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={handlePerfil}>Mi perfil</MenuItem>
                <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
              </Menu>
            </Box>
          )}

          {!user && location.pathname !== '/' && (
            <Button color="inherit" onClick={() => navigate('/login')}>
              Iniciar sesión
            </Button>
          )}
          {!user && location.pathname === '/' && (
            <Button color="inherit" onClick={() => navigate('/register')}>
              Registrarme
            </Button>
          )}
        </Toolbar>
      </AppBar>

      {user && <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} user={user} setUser={setUser} />}
    </>
  );
};

export default Header;
